let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dmgw9")).then(() => parcelRequire('kuFA7'));